import { render } from "./DisplayProp.vue?vue&type=template&id=18d9fed6"
import script from "./DisplayProp.vue?vue&type=script&lang=js"
export * from "./DisplayProp.vue?vue&type=script&lang=js"

import exportComponent from "/data/home/geraldo/git/Intmain/lowcarb/frontend/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__